import { render, staticRenderFns } from "./AdminMedicamentoAplicado.vue?vue&type=template&id=65e2e942&"
import script from "./AdminMedicamentoAplicado.vue?vue&type=script&lang=js&"
export * from "./AdminMedicamentoAplicado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports